import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs';
import {AuthApiService} from '../services/auth-api.service';

export const authGuard: CanActivateFn = (route) => {
  const auth = inject(AuthApiService);
  const router = inject(Router);

  return auth.loadSession().pipe(
    map(ok => ok ? true : router.createUrlTree(['/login'], { queryParams: route.queryParams }))
  );
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthApiService);
  const router = inject(Router);

  return auth.loadSession().pipe(
    map(ok => ok && auth.isAdmin() ? true : router.createUrlTree(['/main']))
  );
};

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthApiService);
  const router = inject(Router);

  return auth.loadSession().pipe(
    map(ok => ok && auth.isSuperAdmin() ? true : router.createUrlTree(['/main']))
  );
};

export const guestGuard: CanActivateFn = (route) => {
  const auth = inject(AuthApiService);
  const router = inject(Router);

  return auth.loadSession().pipe(
    map(ok => {
      if (!ok) return true;
      if (route.queryParamMap.has('client_id')) return true;
      const origin = route.queryParamMap.get('origin');
      const redirectUri = route.queryParamMap.get('redirect_uri') ?? route.queryParamMap.get('returnUrl');
      const queryParams: Record<string, string> = {};
      if (origin) queryParams['origin'] = origin;
      if (redirectUri) queryParams['redirect_uri'] = redirectUri;
      return router.createUrlTree(['/main'], { queryParams });
    })
  );
};
